<template>
  <v-layout column>
    <v-btn to="add-tenant" color="info">
      Add a Tenant
    </v-btn>
    <tenant
      v-for="ten in tenants"
      :key="ten.id"
      :tenant="ten"
      class="my-2"
      attach="body"
      @remove="confirm"
      @edit="$router.push('edit-tenant/' + $event)"
    />
    <v-dialog v-model="dialog" width="250">
      <v-card>
        <v-card-title class="headline red">
          Confirm Delete
        </v-card-title>
        <v-card-text>Are you sure you want to delete?</v-card-text>
        <v-card-actions>
          <v-layout justify-space-around>
            <v-btn @click="dialog = false">
              Back
            </v-btn>
            <!--<v-btn color="error" @click="remove">Delete</v-btn>-->
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import Tenant from './Tenant.vue';

export default {
  name: 'Tenants',
  components: { Tenant },
  data: () => ({
    dialog: false,
    tenantToRemove: null,
    tenants: [],
  }),
  firestore: {
    tenants: db
      .collection('users')
      .where('admin', '==', getUid())
      .where('accountType', '==', 'tenant'),
  },
  methods: {
    confirm(id) {
      this.dialog = true;
      this.tenantToRemove = id;
    },
    // TODO: make a way to remove tenants
    // async remove() {
    //   await db
    //     .collection('tenants')
    //     .doc(this.tenantToRemove)
    //     .delete();
    //   this.tenantToRemove = null;
    //   this.dialog = false;
    // },
  },
};
</script>

<style></style>
